module.exports = __webpack_public_path__ + "a22b62e93a2a3b412ad85e283d54fa9c.MP3";